import React, { Component } from 'react';
import { connect } from 'react-redux';
import DualButtons from 'components/DualButtons';
import {
  Tab,
  TabList,
  TabPanel,
  Tabs,
} from 'react-tabs';
import cx from 'classnames';
import List from 'components/List';
import ListItem from 'components/List/ListItem';
import Header from 'components/CardShell/Header';
import MultiSelectedSvg from 'images/multiSelected.svg';
import MultiUnselectedSvg from 'images/multiUnselected.svg';
import { Link } from 'react-router-dom';
import StatePicker from './StatePicker';
import styles from './styles.scss';

class ShipmentStates extends Component {
  handleCalculatedEventSelect = (e) => {
    this.props.updateState({ calculated_events: e.map(i => this.props.availableCalculatedEvents[i].id) });
  };

  handleSelectAllEventsClick = () => {
    this.props.updateState({ calculated_events: this.props.availableCalculatedEvents.map(e => e.id) });
  };

  handleUnselectAllEventsClick = () => {
    this.props.updateState({ calculated_events: [] });
  };

  handleCustomEventSelect = (e) => {
    this.props.updateState({ custom_event_types: e.map(i => this.props.availableCustomEvents[i].id) });
  };

  handleSelectAllCustomEventsClick = () => {
    this.props.updateState({ custom_event_types: this.props.availableCustomEvents.map(e => e.id) });
  };

  handleUnselectAllCustomEventsClick = () => {
    this.props.updateState({ custom_event_types: [] });
  };

  handleSectionChange = (page) => {
    this.props.gotoPage(page);
  };

  render() {
    const {
      title,
      formData,
      formData: { calculated_events: calcEventIds },
      formData: { custom_event_types: customEventIds },
      pageTabs,
      supportedStates,
      updateState,
      cancel,
      availableCalculatedEvents,
      availableCustomEvents,
      applyCarrierStateFilter,
      isValid,
    } = this.props;
    return (
      <div className={styles.cardSection}>
        <div className={styles.cardSectionNav}>
          {pageTabs()}
        </div>
        <div className={styles.cardSectionInner}>
          <Header>{title}</Header>
          <p className={styles.numberSection}>
            Choose the shipment states, calculated events, custom events or any combination thereof that you want to be notified about.
            You must select at least one.
          </p>
          {supportedStates && (
            <Tabs>
              <TabList className={cx(styles.tabsContainer)}>
                <Tab className={styles.tab} selectedClassName={styles.selectedTab}>Shipment states</Tab>
                <Tab className={styles.tab} selectedClassName={styles.selectedTab}>Calculated events</Tab>
                <Tab className={styles.tab} selectedClassName={styles.selectedTab}>Custom events</Tab>
              </TabList>
              <TabPanel>
                <StatePicker
                  updateState={updateState}
                  formData={formData}
                  states={supportedStates}
                  applyCarrierStateFilter={applyCarrierStateFilter}
                />
              </TabPanel>
              <TabPanel>
                <div className={styles.actionsContainer}>
                  {availableCalculatedEvents.length === 0 || calcEventIds.length !== availableCalculatedEvents.length
                    ? (
                      <button
                        type="button"
                        className={cx(styles.action, 'button-outline')}
                        onClick={this.handleSelectAllEventsClick}
                      >
                        Select all
                      </button>
                    )
                    : (
                      <button
                        type="button"
                        className={cx(styles.action, 'button-outline')}
                        onClick={this.handleUnselectAllEventsClick}
                      >
                        Unselect all
                      </button>
                    )}
                </div>
                <List
                  className={styles.list}
                  isSelectable
                  isMultiSelect
                  selectedIndexes={calcEventIds.map(id => availableCalculatedEvents.findIndex(g => g.id === id))}
                  onSelectionChange={this.handleCalculatedEventSelect}
                >
                  {availableCalculatedEvents.map(calcEvent => (
                    <ListItem key={calcEvent.id} selectedItemClassName={styles.selectedCalculatedEvent}>
                      <div className={styles.listItem}>
                        <span className={styles.listItemTitle}>{calcEvent.name}</span>
                        <MultiSelectedSvg className={cx(styles.selectIcon, styles.selectedIcon)} />
                        <MultiUnselectedSvg className={cx(styles.selectIcon, styles.unselectedIcon)} />
                      </div>
                    </ListItem>
                  ))}
                </List>
              </TabPanel>
              <TabPanel>
                {availableCustomEvents.length > 0 ? (
                  <>
                    <div className={styles.actionsContainer}>
                      {availableCustomEvents.length === 0 || customEventIds.length !== availableCustomEvents.length
                        ? (
                          <button
                            type="button"
                            className={cx(styles.action, 'button-outline')}
                            onClick={this.handleSelectAllCustomEventsClick}
                          >
                            Select all
                          </button>
                        )
                        : (
                          <button
                            type="button"
                            className={cx(styles.action, 'button-outline')}
                            onClick={this.handleUnselectAllCustomEventsClick}
                          >
                            Unselect all
                          </button>
                        )}
                    </div>
                    <List
                      className={styles.list}
                      isSelectable
                      isMultiSelect
                      selectedIndexes={customEventIds.map(id => availableCustomEvents.findIndex(g => g.id === id))}
                      onSelectionChange={this.handleCustomEventSelect}
                    >
                      {availableCustomEvents.map(custEvent => (
                        <ListItem key={custEvent.id} selectedItemClassName={styles.selectedCalculatedEvent}>
                          <div className={styles.listItem}>
                            <span className={styles.listItemTitle}>{custEvent.name}</span>
                            <MultiSelectedSvg className={cx(styles.selectIcon, styles.selectedIcon)} />
                            <MultiUnselectedSvg className={cx(styles.selectIcon, styles.unselectedIcon)} />
                          </div>
                        </ListItem>
                      ))}
                    </List>
                  </>
                )
                  : (
                    <p>No custom events available, custom events can be created <Link to="/settings/custom-event-types">here</Link></p>
                  )}
              </TabPanel>
            </Tabs>
          )}
        </div>
        <div className={styles.cardSectionButtons}>
          <DualButtons
            leftFunction={cancel}
            leftText="Cancel"
            rightFunction={() => this.handleSectionChange(3)}
            rightText="Next"
            theme="rightPink"
            rightFunctionDisabled={!isValid}
          />
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  groups: state.shipmentFilters.groups,
  availableCalculatedEvents: state.availableCalculatedEvents.values,
}))(ShipmentStates);
